import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';

import FieldText from '../common/FieldText';
import FieldSelect from '../common/FieldSelect';
import Util from '../../util/Util';
import Const from '../../util/Constants';
import MassMailAPI from '../../api/MassMailAPI';
import ValidationController from '../../controller/ValidationController';
import ApiUiController from '../../controller/ApiUiController';

class MassEmailPopup extends React.Component {

  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model).mass_mail;
    this.mass_mail = { id: 0, name: "", template: 0, config: 0, operation_status: 1,
      module: props.model_no};
    this.state = { inApiCall: false, inValid: {}, mass_mail: { ...this.mass_mail } };
  }

  onChange = (field, value) => {
    const mass_mail = { ...this.state.mass_mail };
    mass_mail[field] = value;
    this.setState({ ...this.state, mass_mail: { ...mass_mail }});
  }

  onSave = () => {
    const inValid = ValidationController.validate(this.model.fields, this.state.mass_mail);
    if(inValid === null) {
      const mass_mail = { ...this.state.mass_mail };
      let filters = this.props.filters.filter(ele => ele.field !== 'email_opt');
      mass_mail.filters = filters;
      filters.push({field: 'email_opt', type: 'toggle', condition: 'in', value: ''});
      MassMailAPI.save(mass_mail, this.onSaved, this.onFail);
      this.setState({ ...this.state, inApiCall: true });
    } else { this.setState({ ...this.state, inValid: { ...inValid } }); }
  }

 onFail = (res) =>{
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false })
  };
  onSaved = res => {
    Util.showNotification('Successful', 'Mass Mail saved successfully', 'success');
    this.setState({ ...this.state, mass_mail: {...this.state.mass_mail, id:res.id},inApiCall: false});
    this.props.onHide();
    if(this.props.reload) this.props.reload();
  }

  render() {
    const fields = this.model.fields;
    const mass_mail = this.state.mass_mail;
    const inValid = this.state.inValid;
    return (
      <Modal aria-labelledby="contained-modal-title-vcenter" size="md" show={this.props.show}
        onHide={this.props.onHide} centered onExit={() => this.isAPICalled = false }>
        
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Add Mass Mail</Modal.Title>
        </Modal.Header>
        <ApiUiController inApiCall={this.state.inApiCall}>
          <Modal.Body>
            <Form>
              <FieldText key="name" id="name" field={fields.name}
                value={mass_mail.name} onValueChange={this.onChange} inValid={inValid} />

              <FieldSelect key="template" id="template"
                field={fields.template} value={mass_mail.template}
                onValueChange={this.onChange} inValid={inValid} />

              <FieldSelect key="config" id="config"
                field={fields.config} value={mass_mail.config}
                onValueChange={this.onChange} inValid={inValid} />
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.onSave}>Submit</Button>
          </Modal.Footer>
        </ApiUiController>
      </Modal>  
    );
  }
}
export default MassEmailPopup;